import { Skeleton } from '@/components/ui/skeleton';

export const TranslatePanelTableLoading = () => {
  const items = Array.from({ length: 9 });
  return (
    <div className="flex flex-col gap-4 w-full h-full bg-white rounded-md p-4">
      <Skeleton className="w-full h-[36px]" />
      <div className="flex flex-col gap-1">
        <Skeleton className="w-full h-[40px]" />
        {items.map((_, index) => (
          <div className="flex gap-1" key={index}>
            <Skeleton className="w-full h-[49px]" />
            <Skeleton className="w-full h-[49px]" />
          </div>
        ))}
      </div>
      <Skeleton className="w-full h-[36px]" />
    </div>
  );
};
